const timer = 2500

export const defaultCode = `
const cycleLog = createEvent({name: 'cycleLog'})

const s1 = createStore(-1, {name: 's1'})
const time = createStore(${timer}, {name: 'time'})
const timerFX = createEffect({
  name: 'timerFX',
  handler: time => new Promise(
    rs => setTimeout(rs, time)
  )
})
const messageFX = createEffect({
  name: 'messageFX',
  handler: async message => {
    await new Promise(rs => (
      setTimeout(rs, ${timer}+Math.random()*2e4)
    ))
    if (Math.random() > 0.5) {
      throw Error('message failure')
    }
  }
})
const cycle = createStore(0, {name: 'cycle'})
  .on(timerFX.done, x => x + 1)
  .on(messageFX.finally, x => x + 1)

sample({
  source: time,
  clock: timerFX.done,
  target: timerFX
})

forward({
  from: timerFX.done,
  to: messageFX
})

forward({
  from: cycle,
  to: s1
})
forward({
  from: cycleLog,
  to: s1
})

cycle.watch(e => {
  console.log('cycle', e)
  if (Math.random() > 0.5) {
    cycleLog(e + 1)
  }
})

const forceLoginCheck = createEvent({name: 'forceLoginCheck'})
const applyUsernameDraft = createEvent({name: 'applyUsernameDraft'})

const username = createStore('alice', {name: 'username'})
const usernameDraft = createStore('bob', {name: 'usernameDraft'})
const isSignedIn = createStore(true, {name: 'isSignedIn'})

const getUserInfoFx = createEffect({name: 'getUserInfoFx'})

username.on(getUserInfoFx.done, (_, {result}) => result.login)
username.on(isSignedIn, (username, isSignedIn) => username)
username.on(cycle, (username, cycle) => username)

sample({
  source: username,
  clock: isSignedIn,
  target: getUserInfoFx,
})
sample({
  source: username,
  clock: forceLoginCheck,
  target: getUserInfoFx,
})
sample({
  source: usernameDraft,
  clock: applyUsernameDraft,
  target: username,
})


initialized()

await timerFX(cycle.getState())
`
